import { render, staticRenderFns } from "./ArchiveButton.vue?vue&type=template&id=b45b74c0"
import script from "./ArchiveButton.vue?vue&type=script&lang=js"
export * from "./ArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports